import React from 'react';
import { SimpleModal } from 'app/components/Modal';
import StudyGuideDataGrid from './StudyGuideDataGrid';

export default function StudyGuideModal(props) {
  const { show, onClose, data } = props;

  return (
    <SimpleModal
      show={show}
      onClose={onClose}
      contentClassName="simple-modal__content--lg"
      hideCloseButton
    >
      <h3 className="modal__simple-title">Interação com o guia</h3>

      <StudyGuideDataGrid
        data={data}
        height={366}
      />
    </SimpleModal>
  );
}
